document.addEventListener('DOMContentLoaded', () => {
    const cartCookieName = 'cart_ts';
    const expiryDays = 14;
    
    const isCookieExpired = (cookieName, days) => {
      const cookieValue = document.cookie
        .split('; ')
        .find(row => row.startsWith(`${cookieName}=`))
        ?.split('=')[1];
      
      if (cookieValue) {
        const cartTimestamp = parseInt(cookieValue, 10);
        const currentTimestamp = Math.floor(Date.now() / 1000); // Convert to seconds
        const daysDifference = (currentTimestamp - cartTimestamp) / (60 * 60 * 24);
        
        return daysDifference > days;
      }
      
      return false;
    };
    
    if (isCookieExpired(cartCookieName, expiryDays)) {
      // Clear cart using Shopify's AJAX API
      fetch('/cart/clear.js', {
        method: 'POST'
      }).then(() => {
        console.log('Cart has been cleared due to inactivity.');
      }).catch(err => {
        console.error('Failed to clear cart:', err);
      });
    }
  });


  (function (ns, fetch) {
    if (typeof fetch !== 'function') return;
  
    ns.fetch = function () {
      const responsePromise = fetch.apply(this, arguments);
  
      responsePromise
        .then((response) => {
          const cartEndpoints = [
            '/cart/add.js',
            '/cart/update.js',
            '/cart/change.js',
            '/cart/clear.js',
          ];
  
          // Check if the response URL matches any of the cart endpoints
          if (cartEndpoints.some((endpoint) => response.url.includes(endpoint))) {
            response
              .clone()
              .json()
              .then((data) => {
                console.log('Cart updated:', data);
                // Here you can add logic to update local storage, refresh UI, etc.
              })
              .catch((error) => console.error('Error parsing JSON:', error));
          }
        })
        .catch((error) => console.error('Fetch failed:', error));
  
      return responsePromise;
    };
  })(window, window.fetch);